import { Row } from 'react-table';

export const createTimestampColumn =
    (key: string) =>
    ({ row }: { row: Row }) =>
        <>{new Date(parseInt(row.values[key]) * 1000).toLocaleString()}</>;
